<template>
  <div :class="[isShowText ? 'zy_back' : 'zy_back_ani']" @click="onBack">
    <div class="back_text" v-if="isShowText">{{ text }}</div>
    <img class="back_icon" :src="icon" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ZyBack',
  props: {
    icon: {
      type: String,
      default: 'https://fruitsoss.yunyihudong.com/weixin_h5/images/v110/right_icon.png'
    },
    text: {
      type: String,
      default: '回到首页'
    },
    backPath: {
      type: String,
      default: '/HomePage'
    },
    isShowText: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([])
  },
  watch: {},
  created() {},
  methods: {
    onBack() {
      this.$emit('onBack')
      this.$router.replace({
        path: this.backPath
      })
    }
  }
}
</script>

<style lang="less" scoped>
.zy_back,
.zy_back_ani {
  position: absolute;
  top: 20px;
  right: 0;
  width: 190px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-top-left-radius: 34px;
  border-bottom-left-radius: 34px;
  z-index: 999;
  padding-left: 10px;
  box-sizing: border-box;
}

.zy_back_ani {
  animation: backLeftAni 280ms;
  animation-fill-mode: forwards;
}

.back_icon {
  width: 32px;
  height: 32px;
}

.back_text {
  font-size: 28px;
  font-weight: 400;
  color: #fff;
}

@keyframes backLeftAni {
  0% {
    width: 190px;
  }
  100% {
    width: 68px;
  }
}
</style>
